// components/UpgradeModal.jsx
import React from 'react';
import './UpgradeModal.css';

const PLANS = [
  {
    key:    'starter',
    name:   'Starter',
    price:  '$29',
    period: '/mo',
    leads:  '300 leads / month',
    featured: false,
  },
  {
    key:    'pro',
    name:   'Pro',
    price:  '$79',
    period: '/mo',
    leads:  '1,000 leads / month',
    featured: true,
  },
  {
    key:    'unlimited',
    name:   'Unlimited',
    price:  '$199',
    period: '/mo',
    leads:  'Unlimited leads',
    featured: false,
  },
];

export default function UpgradeModal({ onClose, leadsUsed, leadsLimit }) {
  return (
    <div className="up-overlay" onClick={onClose}>
      <div className="up-modal" onClick={e => e.stopPropagation()}>

        <div className="up-header">
          <div className="up-icon">⚡</div>
          <div className="up-title">You've used all {leadsLimit} free leads</div>
          <div className="up-sub">Upgrade to keep finding NYC restaurant leads with owner direct lines.</div>
        </div>

        <div className="up-plans">
          {PLANS.map(p => (
            <div key={p.key} className={`up-plan${p.featured ? ' up-plan-featured' : ''}`}>
              {p.featured && <div className="up-plan-badge">Most Popular</div>}
              <div className="up-plan-top">
                <span className="up-plan-name">{p.name}</span>
                <span className="up-plan-price">
                  {p.price}<span className="up-plan-per">{p.period}</span>
                </span>
              </div>
              <div className="up-plan-leads">{p.leads}</div>
              <button
                className={`up-plan-btn${p.featured ? ' up-plan-btn-featured' : ''}`}
                onClick={() => alert('Payment coming soon — contact us to upgrade')}
              >
                Get {p.name}
              </button>
            </div>
          ))}
        </div>

        <button className="up-dismiss" onClick={onClose}>Maybe later</button>
      </div>
    </div>
  );
}